import AMapLoader from '@amap/amap-jsapi-loader';
import amapConfig from '../config/amapConfig';

let geocoderInstance = null;

/**
 * 初始化 Geocoder 插件
 */
async function initGeocoder(city = "上海") {
  if (geocoderInstance) return geocoderInstance;

  try {
    if (!window._AMapSecurityConfig) {
      window._AMapSecurityConfig = { securityJsCode: amapConfig.securityJsCode };
    }

    const AMap = await AMapLoader.load({
      key: amapConfig.key,
      version: "2.0",
      plugins: ['AMap.Geocoder']
    });

    geocoderInstance = new AMap.Geocoder({
      city: city,
    });
    return geocoderInstance;
  } catch (e) {
    console.error("Geocoder 插件加载失败", e);
    return null;
  }
}

/**
 * 批量修复缺失坐标的酒店列表 (Promise 版)
 * @param {Array} hotelList - 酒店列表引用
 * @param {Function} onProgress - 进度回调 (percent) => {}
 * @returns {Promise<Boolean>} 完成后返回 true
 */
export async function fixHotelCoordinates(hotelList, onProgress, city = "上海") {
  console.log('[地址解析] 开始修复酒店坐标，目标城市:', city);
  const geocoder = await initGeocoder(city);
  if (!geocoder) return false;

  // 1. 筛选出坐标无效的酒店
  const targets = hotelList.filter(h => {
    const lat = parseFloat(h.Latitude);
    const lng = parseFloat(h.Longitude);
    return !lat || !lng || isNaN(lat) || isNaN(lng) || lat === 0 || lng === 0;
  });

  const total = targets.length;
  if (total === 0) {
    if (onProgress) onProgress(100);
    return true; // 不需要修复
  }

  console.log(`[地址解析] 待修复 ${total} 家酒店，开始同步处理...`);

  // 2. 逐个解析 (串行执行，确保全部完成)
  let count = 0;
  for (const hotel of targets) {
    const address = hotel.AddressCn || hotel.HotelNameCn;

    if (address) {
      try {
        // 封装单次请求为 Promise，确保 await 生效
        await new Promise((resolve) => {
          geocoder.getLocation(address, (status, result) => {
            if (status === 'complete' && result.geocodes.length) {
              const location = result.geocodes[0].location;
              // 回填数据
              hotel.Longitude = location.lng;
              hotel.Latitude = location.lat;

              // 兼容字段
              hotel.lng = location.lng;
              hotel.lat = location.lat;
            }
            // 无论成功失败，都算处理完成
            resolve();
          });
        });
      } catch (err) {
        console.warn('解析异常', err);
      }
    }

    count++;
    // 更新进度
    if (onProgress) {
      const percent = Math.floor((count / total) * 100);
      onProgress(percent);
    }

    // 强制延时 100ms，防止高德 QPS 超限封控
    await new Promise(r => setTimeout(r, 100));
  }

  console.log('[地址解析] 全部完成');
  return true;
}